import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/">GifsCopyPaste.com</Link>
          </div>
          <nav className="main-nav">
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/category/emoji-categories">Emoji Categories</Link></li>
              <li><Link to="/category/love-messages">Love Messages</Link></li>
              <li><Link to="/category/heart-collections">Heart Collections</Link></li>
              <li><Link to="/category/tools">Tools</Link></li>
              <li><Link to="/category/blog">Blog</Link></li>
            </ul>
          </nav>
          <div className="search-icon">
            <button className="search-button-header">🔍</button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
